module.exports = __webpack_public_path__ + "static/media/Kravi_hora.a4188ea6.md";